import _ from 'lodash'
import styled from 'styled-components'

const InputContainer = styled.label`
  width: ${p => p.width};
  height: ${p => p.height || '60px'};
  display: flex;
  position: relative;
  margin-bottom: 20px;
  cursor: ${p => (p.disabled ? 'default' : 'text')};
  &, * {
    box-sizing: border-box;
  }

  &:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid
      ${p =>
        p.theme.color[p.error ? 'red' : p.disabled ? 'background' : 'pale']};
  }

  &:hover:not(:focus-within):after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 10px;
    border: 1px solid
      ${p =>
        p.theme.color[p.error ? 'red' : p.disabled ? 'background' : 'pale']};
  }
  
  > div {
    display: flex;
    position: absolute;
    left: 20px;
    top: 20px;
    svg {
      transition: 0.2s ease all;
      height: 20px;
      width: 20px;
      fill: ${p =>
              p.value || _.isNumber(p.value)
                      ? p.theme.color.gray
                      : p.theme.color.disabled};
    }
  }
`

const InputStyle = styled.input`
  box-sizing: border-box;
  font-size: ${p => p.fontSize || '16px'};
  width: 100%;
  height: 100%;
  color: ${p => p.theme.color.mainFont};
  background-color: ${p => p.theme.color.background};
  border-radius: 10px;
  padding-left: ${p => (p.icon ? '55' : p.paddingLeft || '20')}px;
  padding-top: ${p => p.text ? '20px' : '0px'};
  padding-right: ${p => p.text ? '20px' : '0px'};
  outline: none;
  border: none;
  position: relative;
  display: flex;

  &::placeholder {
    opacity: 0;
    color: ${p => p.theme.color.disabled};
  }

  &:focus {
    background-color: ${p => p.theme.color.backgroundRush};
    border: 1px solid ${p => p.theme.color.background};
    padding-left: ${p => (p.icon ? '54' : p.paddingLeft ? p.paddingLeft - 1 : '19')}px;
    padding-right: 40px;

    &::placeholder {
      opacity: 1;
    }

    & ~ span {
      &:first-of-type {
        top: 12px;
        font-size: 12px;
        color: ${p => p.theme.color.gray};
      }

      &:last-of-type svg {
        fill: ${p => p.theme.color.gray};
      }
    }
  }

  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
`

export const InputText = styled.span`
  position: absolute;
  left: ${p => (p.textLeft ? p.textLeft : p.icon ? '55px' : '20px')};
  top: ${p =>
    p.textTop ? p.textTop : p.value || _.isNumber(p.value) ? '12px' : '20px'};
  font-size: ${p => (p.value || _.isNumber(p.value) ? '12px' : '16px')};
  color: ${p => (p.value ? p.theme.color.gray : p.theme.color.mainFont)};
  transition: 0.2s ease all;
`

export const Styled = {
  InputContainer,
  InputStyle,
  InputText,
}
